import {
  ReportBuilderDataSourceId,
  TemplateScope,
} from '@principle-theorem/principle-core/interfaces';
import { FactTables } from '../../models/fact-tables';
import { toMeasureBuilderData } from '../../models/measure-properties';
import { ReportBuilderColumns } from '../../report-builder-columns';
import { ChartFilterDefinition } from '../charts/chart-filter-definition';
import { ReportBuilderCharts } from '../charts/report-builder-charts';
import { ReportBuilderCommonCharts } from '../charts/report-builder-common-charts';
import { ReportBuilderDataSourceInstance } from '../report-builder-data-source-instance';
import { ReportBuilderGroups } from '../report-builder-groups';
import { ReportBuilderScopeDataAccessors } from '../report-builder-scope-data-accessors';

export class PatientInteractionsDataSource extends ReportBuilderDataSourceInstance {
  override readonly id = ReportBuilderDataSourceId.PatientInteractions;
  override readonly name = 'Patient Interactions';
  override readonly description = '';
  override readonly factTable = FactTables.patientInteractionEvent.latestEvent;
  override readonly rowItemName = 'Patient Interaction';

  override readonly queryableTimestamps = [
    { property: this.factTable.interaction.createdAt },
  ];

  scopes = [TemplateScope.Patient];
  scopeDataAccessor = ReportBuilderScopeDataAccessors.build([
    this.factTable.patient,
  ]);

  override readonly groupByOptions = [
    ReportBuilderGroups.toGroup('Common', [
      ReportBuilderGroups.toOption(this.factTable.brand.name),
      ReportBuilderGroups.toOption(this.factTable.count),
    ]),
    ReportBuilderGroups.patientInteraction(this.factTable.interaction),
    ReportBuilderGroups.patient(this.factTable.patient),
  ];

  override readonly availableColumns = [
    ReportBuilderColumns.toColumnGroup(
      'Patient Interaction',
      ReportBuilderColumns.patientInteraction(this.factTable.interaction)
    ),
    ReportBuilderColumns.toColumnGroup('Patient', [
      ...ReportBuilderColumns.patient(this.factTable.patient),
      this.factTable.patientLink,
    ]),
  ];

  override readonly defaultColumns = ReportBuilderColumns.toReferences([
    this.factTable.interaction.createdAt,
    this.factTable.patient.name,
    this.factTable.interaction.owner,
    this.factTable.interaction.title,
    this.factTable.interaction.type,
    this.factTable.interaction.pinned,
    this.factTable.interaction.tags,
    this.factTable.interaction.content,
  ]);

  override readonly availableCharts = [
    ReportBuilderCharts.predefined(
      'overview.brand.price',
      this.factTable.brand.name,
      ChartFilterDefinition.numberSummary(
        'Total Interactions',
        this.factTable.brand.name,
        [toMeasureBuilderData(this.factTable.count)]
      )
    ),
    ...ReportBuilderCommonCharts.patientInteraction(
      this.factTable.interaction,
      this.factTable.count
    ),
    ...ReportBuilderCommonCharts.patient(
      this.factTable.patient,
      this.factTable.count
    ),
  ];
}
